<section class="app-dialog table-page tickets-reporte-preview">
  <header class="app-dialog__header">
    <div class="app-dialog__heading">
      <div class="tickets-reporte-icono" aria-hidden="true">
        <mat-icon>table_view</mat-icon>
      </div>

      <div>
        <p class="app-dialog__eyebrow">Reporte de tickets</p>
        <h2 id="tickets-reporte-preview-titulo">Vista previa del reporte</h2>
        <p>Son las mismas filas que trae el Excel.</p>
      </div>
    </div>

    <button
      type="button"
      mat-icon-button
      class="app-dialog__close"
      aria-label="Cerrar vista previa"
      [disabled]="generando"
      (click)="cerrar()">
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </header>

  <div mat-dialog-content class="app-dialog__content tickets-reporte-preview__content">
    <div class="tickets-reporte-preview__resumen">
      <ul class="tickets-reporte-preview__filtros" aria-label="Filtros aplicados">
        @for (filtro of resumen; track filtro) {
          <li class="tickets-reporte-preview__filtro">{{ filtro }}</li>
        }
      </ul>
      @if (cargado && !errorCarga) {
        <p class="tickets-reporte-preview__total" aria-live="polite">
          <strong>{{ total | number }}</strong> {{ total === 1 ? "ticket" : "tickets" }}
        </p>
      }
    </div>

    <output class="tickets-reporte-preview__estado" aria-live="polite">
      @if (resultado === "vacio") {
        <div class="tickets-reporte-aviso tickets-reporte-aviso--vacio">
          <mat-icon aria-hidden="true">search_off</mat-icon>
          <div class="tickets-reporte-aviso__texto">
            <strong>Sin tickets para estos filtros.</strong>
            <span>{{ sugerencia }}</span>
          </div>
        </div>
      }
      @if (resultado === "exito") {
        <div class="tickets-reporte-aviso tickets-reporte-aviso--exito">
          <mat-icon aria-hidden="true">task_alt</mat-icon>
          <div class="tickets-reporte-aviso__texto">
            <strong>Se descargó el reporte.</strong>
          </div>
        </div>
      }
    </output>

    @if (resultado === "error") {
      <div class="tickets-reporte-aviso tickets-reporte-aviso--error" role="alert">
        <mat-icon aria-hidden="true">error_outline</mat-icon>
        <div class="tickets-reporte-aviso__texto">
          <strong>No se pudo generar el reporte.</strong>
          @if (detalleError) {
            <span>{{ detalleError }}</span>
          }
        </div>
      </div>
    }

    <div class="table-page__card tickets-reporte-preview__card">
      @if (errorCarga) {
        <div class="table-page__empty-state" role="alert">
          <mat-icon aria-hidden="true">cloud_off</mat-icon>
          <strong>No se pudo cargar la vista previa</strong>
          <p>{{ errorCarga }}</p>
          @if (filtros) {
            <button
              type="button"
              class="app-form-btn app-form-btn--secondary app-form-btn--compact"
              [disabled]="cargando"
              (click)="cargar()">
              <mat-icon aria-hidden="true">refresh</mat-icon>
              Reintentar
            </button>
          }
        </div>
      } @else if (!cargado) {
        <output class="table-page__empty-state">
          <mat-progress-spinner mode="indeterminate" diameter="28" aria-hidden="true"></mat-progress-spinner>
          <p>Cargando tickets…</p>
        </output>
      } @else if (total === 0) {
        <output class="table-page__empty-state">
          <mat-icon aria-hidden="true">search_off</mat-icon>
          <strong>Sin tickets para estos filtros</strong>
          <p>{{ sugerencia }}</p>
        </output>
      } @else {
        <section
          class="table-page__table-wrap tickets-reporte-preview__tabla-wrap"
          aria-label="Tickets del reporte"
          [class.is-cargando]="cargando"
          [attr.aria-busy]="cargando">
          <table class="table-page__table tickets-reporte-preview__tabla">
            <caption class="cdk-visually-hidden">
              Tickets del reporte, del {{ desde }} al {{ hasta }} de {{ total }}
            </caption>
            <thead>
              <tr>
                <th scope="col">Ticket</th>
                <th scope="col">Asunto</th>
                <th scope="col">Prioridad</th>
                <th scope="col">Empresa solicitante</th>
                <th scope="col">Área solicitante</th>
                <th scope="col">Área resolutora</th>
                <th scope="col">Fecha de apertura</th>
                <th scope="col">Abrió</th>
                <th scope="col">Fecha en proceso</th>
                <th scope="col">Pasó a proceso</th>
                <th scope="col">Fecha de atención</th>
                <th scope="col">Atendió</th>
                <th scope="col">Fecha de Vo.Bo.</th>
                <th scope="col">Dio Vo.Bo.</th>
                <th scope="col">Fecha de cancelación</th>
                <th scope="col">Canceló</th>
                <th scope="col">Tiempo de atención</th>
                <th scope="col">Cumple SLA</th>
                <th scope="col">Estatus</th>
                <th scope="col">Causa origen del problema</th>
                <th scope="col">Paliativo</th>
                <th scope="col">Solución definitiva</th>
                <th scope="col">Impacto</th>
              </tr>
            </thead>
            <tbody>
              @for (fila of filas | paginate: { id: idPaginador, itemsPerPage: tamanoPagina, currentPage: pagina, totalItems: total }; track $index) {
                <tr>
                  <td class="tickets-reporte-preview__id">{{ fila.ticket.id_ticket }}</td>
                  <td class="tickets-reporte-preview__largo"><span class="tickets-reporte-preview__recorte" [attr.title]="fila.ticket.asunto || null">{{ fila.ticket.asunto || "—" }}</span></td>
                  <td>
                    @if (fila.ticket.prioridad) {
                      <span class="table-page__status-badge" [class]="fila.clasePrioridad">{{ fila.ticket.prioridad }}</span>
                    } @else {
                      —
                    }
                  </td>
                  <td>{{ fila.ticket.nombreEmpresaSolicitante || "—" }}</td>
                  <td>{{ fila.ticket.areaSolicitante || "—" }}</td>
                  <td>{{ fila.ticket.areaResolutora || "—" }}</td>
                  <td class="tickets-reporte-preview__fecha">{{ (fila.ticket.fechaSolicitud | date: "dd/MM/yyyy HH:mm") || "—" }}</td>
                  <td>{{ fila.ticket.nombreSolicitante || "—" }}</td>
                  <td class="tickets-reporte-preview__fecha">{{ (fila.ticket.fechaProceso | date: "dd/MM/yyyy HH:mm") || "—" }}</td>
                  <td>{{ fila.ticket.nombreUsuarioProceso || "—" }}</td>
                  <td class="tickets-reporte-preview__fecha">{{ (fila.ticket.fechaAtendio | date: "dd/MM/yyyy HH:mm") || "—" }}</td>
                  <td>{{ fila.ticket.nombreUsuarioAtendio || "—" }}</td>
                  <td class="tickets-reporte-preview__fecha">{{ (fila.ticket.fechaVoBo | date: "dd/MM/yyyy HH:mm") || "—" }}</td>
                  <td>{{ fila.ticket.nombreUsuarioVoBo || "—" }}</td>
                  <td class="tickets-reporte-preview__fecha">{{ (fila.ticket.fechaCancelada | date: "dd/MM/yyyy HH:mm") || "—" }}</td>
                  <td>{{ fila.ticket.nombreUsuarioCancelo || "—" }}</td>
                  <td>{{ fila.ticket.tiempoAtencionString || "—" }}</td>
                  <td>
                    @if (fila.sla) {
                      <span class="table-page__status-badge" [class]="fila.sla.clase">{{ fila.sla.texto }}</span>
                    } @else {
                      —
                    }
                  </td>
                  <td>
                    @if (fila.ticket.nombreEstaus) {
                      <span class="table-page__status-badge" [class]="fila.claseEstatus">{{ fila.ticket.nombreEstaus }}</span>
                    } @else {
                      —
                    }
                  </td>
                  <td class="tickets-reporte-preview__largo"><span class="tickets-reporte-preview__recorte" [attr.title]="fila.ticket.causaOrigenProblema || null">{{ fila.ticket.causaOrigenProblema || "—" }}</span></td>
                  <td class="tickets-reporte-preview__largo"><span class="tickets-reporte-preview__recorte" [attr.title]="fila.ticket.paliativo || null">{{ fila.ticket.paliativo || "—" }}</span></td>
                  <td class="tickets-reporte-preview__largo"><span class="tickets-reporte-preview__recorte" [attr.title]="fila.ticket.solucionDefinitiva || null">{{ fila.ticket.solucionDefinitiva || "—" }}</span></td>
                  <td class="tickets-reporte-preview__largo"><span class="tickets-reporte-preview__recorte" [attr.title]="fila.ticket.impacto || null">{{ fila.ticket.impacto || "—" }}</span></td>
                </tr>
              }
            </tbody>
          </table>
        </section>

        <div class="table-page__footer tickets-reporte-preview__pie">
          <div class="table-page__meta">
            <span>Mostrando {{ desde | number }}–{{ hasta | number }} de {{ total | number }}</span>
            <label class="table-page__page-size">
              <span>Ver</span>
              <select aria-label="Ver tickets por página" (change)="cambiarTamano($any($event.target).value)">
                <ng-container>
                  @for (tamano of tamanos; track tamano) {
                    <option [value]="tamano" [selected]="tamano === tamanoPagina">{{ tamano }}</option>
                  }
                </ng-container>
              </select>
            </label>
          </div>

          <pagination-template
            #paginador="paginationApi"
            [id]="idPaginador"
            [maxSize]="5"
            (pageChange)="irAPagina($event)">
            @if (paginador.pages.length > 1) {
              <nav class="table-page__pager" aria-label="Páginas de la vista previa">
                <button
                  type="button"
                  class="table-page__pager-link"
                  [disabled]="paginador.isFirstPage()"
                  (click)="paginador.previous()">
                  Anterior
                </button>
                @for (enlace of paginador.pages; track $index) {
                  @if (enlace.label === "...") {
                    <span class="table-page__pager-ellipsis" aria-hidden="true">…</span>
                  } @else {
                    <button
                      type="button"
                      class="table-page__pager-page"
                      [class.is-current]="paginador.getCurrent() === enlace.value"
                      [attr.aria-current]="paginador.getCurrent() === enlace.value ? 'page' : null"
                      [attr.aria-label]="'Página ' + enlace.label"
                      (click)="paginador.setCurrent(enlace.value)">
                      {{ enlace.label }}
                    </button>
                  }
                }
                <button
                  type="button"
                  class="table-page__pager-link"
                  [disabled]="paginador.isLastPage()"
                  (click)="paginador.next()">
                  Siguiente
                </button>
              </nav>
            }
          </pagination-template>
        </div>
      }
    </div>
  </div>

  <footer mat-dialog-actions align="end" class="app-dialog__footer tickets-reporte-preview__footer">
    <button
      type="button"
      class="app-form-btn app-form-btn--secondary app-form-btn--compact"
      [disabled]="generando"
      (click)="cerrar()">
      Cerrar
    </button>
    <button
      #botonDescargar
      type="button"
      class="app-form-btn app-form-btn--primary app-form-btn--compact"
      [disabled]="generando || !filtros || (cargado && total === 0)"
      (click)="descargar()">
      <mat-icon aria-hidden="true">{{ generando ? "hourglass_top" : "download" }}</mat-icon>
      {{ generando ? "Generando…" : "Descargar Excel" }}
    </button>
  </footer>
</section>
